/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FetchBookmarkedPressReleasesRequest
 */
export interface FetchBookmarkedPressReleasesRequest {
    /**
     * ビジネスカテゴリlv1のIDリスト
     * @type {Array<string>}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    busiCateLv1Ids?: Array<string> | null;
    /**
     * 企業カテゴリのIDリスト
     * @type {Array<string>}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    companyCateIds?: Array<string> | null;
    /**
     * エリアのIDリスト
     * @type {Array<number>}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    regionIds?: Array<number> | null;
    /**
     * 取得開始日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    startDate?: string | null;
    /**
     * 取得終了日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    endDate?: string | null;
    /**
     * 次のデータを取得する開始点となる識別子. {unix_timestamp}_{identifier}という形式
     * @type {string}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    cursor?: string | null;
    /**
     * 取得するプレスリリース数
     * @type {number}
     * @memberof FetchBookmarkedPressReleasesRequest
     */
    limit?: number | null;
}

export function FetchBookmarkedPressReleasesRequestFromJSON(json: any): FetchBookmarkedPressReleasesRequest {
    return FetchBookmarkedPressReleasesRequestFromJSONTyped(json, false);
}

export function FetchBookmarkedPressReleasesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchBookmarkedPressReleasesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateLv1Ids': !exists(json, 'busi_cate_lv1_ids') ? undefined : json['busi_cate_lv1_ids'],
        'companyCateIds': !exists(json, 'company_cate_ids') ? undefined : json['company_cate_ids'],
        'regionIds': !exists(json, 'region_ids') ? undefined : json['region_ids'],
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function FetchBookmarkedPressReleasesRequestToJSON(value?: FetchBookmarkedPressReleasesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_lv1_ids': value.busiCateLv1Ids,
        'company_cate_ids': value.companyCateIds,
        'region_ids': value.regionIds,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'cursor': value.cursor,
        'limit': value.limit,
    };
}

